module.exports = __webpack_public_path__ + "static/media/camion_completo.79bac318.svg";